import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, whyUs } from '../../../assets/images';
import AOS from 'aos';
import 'aos/dist/aos.css';

const WhyUs = () => {

      const { t } = useTranslation();

      useEffect(() => {
        AOS.init({ 
          duration: 2000,
          once: false, // Her scroll'da tekrar etsin
        });
      }, []);

  return (
    <div className='pt-[88px] md:pt-[104px] '>
      <div className='min-h-[800px] md:min-h-min'>
        <div className='max-w-containerSm md:max-w-container mx-auto'>
        <div>
        <p className='text-[24px] md:text-[32px] font-medium text-[#008A7F]'>{t("Biz Kimik?")}</p>
        <p className='text-[14px] md:text-[16px] text-[#767676] mt-4'>{t("Akond şirkəti Azərbaycanda 1997-ci ildən MEP sistemləri (isitmə, soyutma, havalandırma, santexnika, yanğınsöndürmə, elektrik, zəif axım, avtomatlaşdırma sistemləri) üzrə mühəndislik, təchizat, quraşdırma, təmir/servis xidmətləri göstərməkdədir.")}</p>
        </div>
        {/* Desktop versiyonu */}
        <div className='relative md:flex items-center mt-8  hidden'>
  {/* Sağ div */}
  <div className='w-[55%] ml-auto z-0'>
    <img className='w-full h-full object-cover' src={whyUs} />
  </div>

  {/* Sol div - sağ divin üstüne binsin */}
  <div className='absolute left-0 z-10 w-[55%] bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
    <p className='text-[#1C1C1C] font-medium text-[24px]'>Rahatlıq və Etibarlılığın Ünvanı</p>
    <p className='mt-3 text-[#1C1C1C]'>
    Şirkətimiz iri və kiçik həcmli zavod və fabriklərin, neft və qaz sektoru, sənaye və iaşə obyektlərinin, mehmanxana və çoxmərtəbəli iş mərkəzlərinin, luks yaşayış binalarının, idman və konsert komplekslərinin, stadionların, ticarət mərkəzlərinin, xəstəxanaların, məktəblərin, universitetlərin MEP sistemlərinin quraşdırılması və servisinin yerinə yetirilməsində 25 ilə yaxın dolğun təcrübəyə malikdir.
    </p>
    <a href='/about' className="group">
      <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px]'>
        <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
        <img
              className='w-2 transition-opacity duration-300 group-hover:hidden' 
              src={rightArrow}
              alt=""
            />
            <img
              className='w-2 transition-opacity duration-300 hidden group-hover:block'
              src={rightArrowHover}
              alt=""
            />
      </div>
    </a>
  </div>
</div> 
      {/* Mobil versiyon */}
<div className='relative md:hidden items-center mt-8 '>
  {/* Yukarı div */}
  <div className='ml-auto z-0'>
    <img className='w-full h-full object-cover' src={whyUs} />
  </div>

  {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
  <div className='absolute top-[190px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
    <p className='text-[#1C1C1C] font-medium text-[18px]'>Rahatlıq və Etibarlılığın Ünvanı</p>
    <p className='mt-3 text-[#1C1C1C]'>
      Şirkətimiz iri və kiçik həcmli zavod və fabriklərin, neft və qaz sektoru, sənaye və iaşə obyektlərinin, mehmanxana və çoxmərtəbəli iş mərkəzlərinin, luks yaşayış binalarının, idman və konsert komplekslərinin, stadionların, ticarət mərkəzlərinin, xəstəxanaların, məktəblərin, universitetlərin MEP sistemlərinin quraşdırılması və servisinin yerinə yetirilməsində 25 ilə yaxın dolğun təcrübəyə malikdir.
    </p>
    <a href='/about'>
      <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
        <p>Ətraflı</p>
        <img className='w-2' src={rightArrow} />
      </div>
    </a>
  </div>
</div>

 
    </div>
    </div>
    </div>
  )
}

export default WhyUs